import React from 'react'

function Crms() {
  return (
    <div>Coming Soon</div>
  )
}

export default Crms